export default __webpack_public_path__ + "static/media/powerAndRenewables.bfa5ef00.jpg";